<template>
    <div class="layout-column noscroll">
        <div class="top_info_box justify-between">
            <div class="title">Analytics</div>

	        <div class="flex"></div>
	        <div class="layout-row range-wrapper">
		        <range-picker :end-date="endDate" :start-date="startDate"
		                      @reload="loadAnalytics()" :loading="loading"
		                      :min-date="minDate" :max-date="maxDate" @rangeChanged="rangeChanged"/>
	        </div>
        </div>

            <div class="main-content funnel-analytics-content scroll" style="padding: 40px 20px 60px;">
	            <div class="layout-row flex" style="margin-top: 40px;">

		            <chart class="margin-10" title="Revenue" :data="purchaseValues" :old-data="oldPurchaseValues" :prefix="currencyCode"
		                   :total="purchaseValue" :old-total="oldPurchaseValue" is-money
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading"/>
	            </div>

	            <div class="layout-row flex" style="margin-top: 5px;">
		            <chart class="margin-10" title="Orders" :data="purchasesData" :old-data="oldPurchasesData" :round-value="true"
		                   :total="purchases" :old-total="oldPurchases"
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading"/>

		            <chart class="margin-10" title="AOV" :data="aovData" :old-data="oldAovData" :prefix="currencyCode"
		                   :total="aov" :old-total="oldAov" is-money
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading">
			            <template v-slot:info>
				            <b>Average Order Value</b> - is calculated by dividing the total revenue of all customers by the
				            number of unique buyers within the select time period.
			            </template>
		            </chart>
	            </div>

	            <div class="layout-row flex" style="margin-top: 5px;">
		            <chart class="margin-10" title="Page views" :data="visitorsData" :old-data="oldVisitorsData"
		                   :total="visitors" :old-total="oldVisitors"
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading"/>

		            <chart class="margin-10" title="Optins" :data="optinsData" :old-data="oldOptinsData" :round-value="true"
		                   :total="optins" :old-total="oldOptins"
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading"/>
	            </div>
	            <div class="layout-row flex" style="margin-top: 5px;">
		            <chart class="margin-10" title="Conversion rate" :data="convRates" :old-data="oldConvRates" suffix="%"
		                   :total="convRate" :old-total="oldConvRate"
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading"/>

		            <chart class="margin-10" title="Optin rate" :data="optinRates" :old-data="oldOptinRates" suffix="%"
		                   :total="optinRate" :old-total="oldOptinRate"
		                   :startDate="chartStart" :endDate="chartEnd" :loading="loading"/>
	            </div>


	            <div class="performance-breakdown noscroll" style="height: auto;margin-top: 77px;">
                    <h2>Performance breakdown</h2>
                    <div class="analytics-table-container scroll" style="position: relative;">
                        <Loading v-show="loading"/>
                        <table class="analytics-table table-analitics">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="th-wrap">
                                            Step
                                        </div>
                                    </th>
	                                <th>
		                                <div class="th-wrap">
			                                Page views
		                                </div>
	                                </th>
	                                <th>
                                        <div class="th-wrap">
                                            Revenue
                                        </div>
                                    </th>
	                                <th>
		                                <div class="th-wrap">
			                                Orders
		                                </div>
	                                </th>
	                                <th>
		                                <div class="th-wrap">
			                                Conv. rate
		                                </div>
	                                </th>
                                    <th>
                                        <div class="th-wrap">
                                            Optins
                                        </div>
                                    </th>
                                    <th>
                                        <div class="th-wrap">
                                            Optin rate
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(step, index) in steps" :key="index" :class="{deleted: step.is_deleted}" :data-id="step.step_id">
                                    <td>
                                        <div class="step-name">

                                            <strong v-if="step.is_deleted" class="name">{{ step.step_name }}</strong>

                                            <router-link v-else :to="'/funnel/'+$route.params.id+'/steps/'+step.step_id">
                                                <strong class="name">{{ step.step_name }}</strong>
                                            </router-link>
                                        </div>
                                    </td>
	                                <td >
		                                <value-diff :value="step.visits" :old-value="step.old_visits" suffix="" />
	                                </td>

	                                <td >
			                                <value-diff :value="step.revenue" :old-value="step.old_revenue"
			                                            :prefix="currencyCode" is-money />
		                                </td>
		                                <td >
			                                <value-diff :value="step.orders" :old-value="step.old_orders" suffix="" />
		                                </td>
		                                <td >
			                                <value-diff :value="percentage(step.orders, step.visits)"
			                                            :old-value="percentage(step.old_orders, step.old_visits)"
			                                            suffix="%" :digits="2" />
		                                </td>
                                    <td >
	                                    <value-diff :value="step.optins" :old-value="step.previous_optins" suffix="" />
                                    </td>
                                    <td >
	                                    <value-diff :value="percentage(step.optins, step.visits)"
	                                                :old-value="percentage(step.old_optins, step.old_visits)"
	                                                suffix="%" :digits="2" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

	            <div class="layout-column flex-center">
		            <p class="alert_box blue">
			            <inline-svg class="icon" :src="require('@/assets/img/info_icon.svg')" />
			            Your feedback helps us improve, let us know about any missing metrics or inaccuracies.
		            </p>
	            </div>

            </div>
    </div>
</template>

<script>

import API from "@/api"
import {mapGetters} from "vuex"
import Loading from "@/components/Loading.vue"
import ValueDiff from "@/views/funnels/funnel/valueDiff";
import {getSymbol} from "@/helpers/currencies";
import Chart from "@/components/base/chart";
import moment from 'moment';
import RangePicker from "@/components/base/range-picker";
import analytics, {percentage} from "@/helpers/analytics";

export default {
    name: "Analytics",
    components: {
	    RangePicker,
	    Chart,
	    ValueDiff,
      Loading
    },
    mixins: [API],
    props: ['id'],
    data() {
	    return {
	        unit: "day",
        	maxDate: new Date(),
	        startDate: new Date(),
	        endDate: new Date(),
		      currentRange: 'Last 30 days',

	        // Purchase values
	        purchaseValue: 0,
	        oldPurchaseValue: 0,
	        purchaseValues: [{value:0},{value:0}],
	        oldPurchaseValues: [{value:0},{value:0}],

	        // Purchases
	        purchases: 0,
	        oldPurchases: 0,
	        purchasesData: [{value:0},{value:0}],
	        oldPurchasesData: [{value:0},{value:0}],

	        // Conv. rate
	        convRate: 0,
	        oldConvRate: 0,
	        convRates: [{value:0},{value:0}],
	        oldConvRates: [{value:0},{value:0}],

		    // AOV
		    aov: 0,
		    oldAov: 0,
		    aovData: [{value:0},{value:0}],
		    oldAovData: [{value:0},{value:0}],

		    // Visitors
	        visitors: 0,
	        oldVisitors: 0,
	        visitorsData: [{value:0},{value:0}],
	        oldVisitorsData: [{value:0},{value:0}],

	        // Optins
	        optins: 0,
	        oldOptins: 0,
	        optinsData: [{value:0},{value:0}],
	        oldOptinsData: [{value:0},{value:0}],

	        // Optin rate
	        optinRate: 0,
	        oldOptinRate: 0,
	        optinRates: [{value:0},{value:0}],
	        oldOptinRates: [{value:0},{value:0}],

					steps: [],

	        loading: true,
			    loadingSteps: false,
          funnel: {},
        }
    },
    computed: {
        ...mapGetters(["getFunnelStore",]),
	    currencyCode() {
		    let currency = this.getFunnelStore.currency_code;
		    return getSymbol(currency);
	    },
	    chartStart() {
		    return analytics.formatChartDate(this.unit,this.startDate);
	    },
	    oldStartDate() {
		    if (this.unit==="hour") {
			    let days = moment(this.endDate).diff(this.startDate, "hours")+1;
			    let start = moment(this.startDate).subtract(days, "hours");

			    return start;
		    } else {
			    let days = moment(this.endDate).diff(this.startDate, "days")+1;
			    let start = moment(this.startDate).subtract(days, "days");

			    return start;
		    }
	    },
	    chartEnd() {
		    return analytics.formatChartDate(this.unit, this.endDate);
	    },
	    oldEndDate() {
		    if (this.unit==="hour") {
			    let end = moment(this.startDate).subtract(1, "hours").endOf('day');
			    return end;
		    } else {
			    let end = moment(this.startDate).subtract(1, "days").endOf('day');
			    return end;
		    }
	    },
	    minDate() {
		    return moment(this.getFunnelStore.created_at);
	    }
    },
    methods: {
    	percentage(sub,total) {
    		return percentage(sub,total)
	    },
	    rangeChanged(currentRange, startDate, endDate) {
		    this.startDate = startDate;
		    this.endDate = endDate;
		    this.currentRange = currentRange;

		    this.storeRange();

	    	this.loadAnalytics();
	    },
	    storeRange() {
		    analytics.storeRange(this.currentRange, this.startDate, this.endDate);
	    },
	    loadRange() {
		    let {currentRange, startDate, endDate} = analytics.loadRange();

		    this.currentRange = currentRange;
		    this.endDate = endDate;
		    this.startDate = startDate;
	    },
	    async loadAnalytics() {
		    try {
			    let unit = "day";
			    let days = Math.abs(moment(this.endDate).diff(this.startDate, "days"))+1;
			    if (days > 6*30) {
				    unit = "month";
			    } else if (days > 31) {
				    unit = "week";
			    } else if (days <= 2) {
				    unit = "hour"
			    }

			    this.unit = unit;

			    this.loadCharts(unit); // async

			    this.loadPerfBreakdown(unit); // async
		    } catch (e) {
			    this.$error(e)
		    }
	    },
	    async loadCharts(unit) {
		    try {
			    this.loading = true;
			    let id = this.$route.params.id;
			    let data = await this.api.analytics.get(id, this.startDate, this.endDate, unit, this.oldStartDate, this.oldEndDate);

			    // Purchase values
			    this.purchaseValue = data.revenue;
			    this.purchaseValues = analytics.getDataFromTrends(this.unit, data.trends, "revenue", this.startDate, this.endDate)
			    this.oldPurchaseValue = data.old_revenue;
			    this.oldPurchaseValues = analytics.getDataFromTrends(this.unit, data.old_trends, "revenue", this.oldStartDate, this.oldEndDate)

			    // Purchases
			    this.purchases = data.orders;
			    this.purchasesData = analytics.getDataFromTrends(this.unit, data.trends, "orders", this.startDate, this.endDate)
			    this.oldPurchases = data.old_orders;
			    this.oldPurchasesData = analytics.getDataFromTrends(this.unit, data.old_trends, "orders", this.oldStartDate, this.oldEndDate)

			    // AOV
			    this.aov = data.aov;
			    this.aovData = analytics.getDataFromTrends(this.unit, data.trends, "aov", this.startDate, this.endDate)
			    this.oldAov = data.old_aov;
			    this.oldAovData = analytics.getDataFromTrends(this.unit, data.old_trends, "aov", this.oldStartDate, this.oldEndDate)

			    // Visitors
			    this.visitors = data.visits;
			    this.oldVisitors = data.old_visits;

			    if (unit === "hour") {  // handle hourly data differently
				    this.visitorsData = analytics.getDataFromTrends(this.unit, data.hourly_visits, "visits", this.startDate, this.endDate)
				    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, data.old_hourly_visits, "visits", this.oldStartDate, this.oldEndDate)
			    } else {
				    this.visitorsData = analytics.getDataFromTrends(this.unit, data.trends, "visits", this.startDate, this.endDate)
				    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, data.old_trends, "visits", this.oldStartDate, this.oldEndDate)
			    }

			    // Optins
			    this.optins = data.optins;
			    this.optinsData = analytics.getDataFromTrends(this.unit, data.trends, "optins", this.startDate, this.endDate)
			    this.oldOptins = data.old_optins;
			    this.oldOptinsData = analytics.getDataFromTrends(this.unit, data.old_trends, "optins", this.oldStartDate, this.oldEndDate)

			    // Conversion rates
			    this.convRate = percentage(this.purchases, this.visitors);
			    this.convRates = analytics.generateRates(this.visitorsData, this.purchasesData);
			    this.oldConvRate = percentage(this.oldPurchases, this.oldVisitors);
			    this.oldConvRates = analytics.generateRates(this.oldVisitorsData, this.oldPurchasesData);

			    // Optin rates
			    this.optinRate = percentage(this.optins, this.visitors);
			    this.optinRates = analytics.generateRates(this.visitorsData, this.optinsData);
			    this.oldOptinRate = percentage(this.oldOptins, this.oldVisitors);
			    this.oldOptinRates = analytics.generateRates(this.oldVisitorsData, this.oldOptinsData);
		    }catch (e) {
			    console.error(e);
		    } finally {
			    this.loading = false;
		    }
	    },
	    async loadPerfBreakdown(unit) {
		    try {
			    this.loadingSteps = true;
			    this.steps = [];
			    let id = this.$route.params.id;
			    let data = await this.api.analytics.getPerfBreakdown(id, this.startDate, this.endDate, unit, this.oldStartDate, this.oldEndDate);
			    this.steps = data;

		    } catch (e) {
			    console.error(e);
		    } finally {
			    this.loadingSteps = false;
		    }
	    },
	    async loadAnalytics_() {
    		try {
    			let id = this.$route.params.id;
			    this.loading = true;
			    let unit = "day";
			    let days = Math.abs(moment(this.endDate).diff(this.startDate, "days"))+1;
			    if (days > 6*30) {
			    	unit = "month";
			    } else if (days > 31) {
				    unit = "week";
			    } else if (days <= 2) {
				    unit = "hour"
			    }

			    this.unit = unit;

			    let data = await this.api.analytics.get(id, this.startDate, this.endDate, unit);
			    let oldData = await this.api.analytics.get(id, this.oldStartDate, this.oldEndDate, unit);

			    // Purchase values
			    this.purchaseValue = data.purchase_value;
			    this.purchaseValues = analytics.getDataFromTrends(this.unit, data.trends, "purchase_value", this.startDate, this.endDate)
			    this.oldPurchaseValue = oldData.purchase_value;
			    this.oldPurchaseValues = analytics.getDataFromTrends(this.unit, oldData.trends, "purchase_value", this.oldStartDate, this.oldEndDate)

			    // Purchases
			    this.purchases = data.orders;
			    this.purchasesData = analytics.getDataFromTrends(this.unit, data.trends, "orders", this.startDate, this.endDate)
			    this.oldPurchases = oldData.orders;
			    this.oldPurchasesData = analytics.getDataFromTrends(this.unit, oldData.trends, "orders", this.oldStartDate, this.oldEndDate)

			    // Visitors
			    this.visitors = data.visitors;
			    this.oldVisitors = oldData.visitors;
			    if (unit === "hour") {  // handle hourly data differently
				    this.visitorsData = analytics.getDataFromTrends(this.unit, data.hourly_visitors, "visitors", this.startDate, this.endDate)
				    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, oldData.hourly_visitors, "visitors", this.oldStartDate, this.oldEndDate)
			    } else {
				    this.visitorsData = analytics.getDataFromTrends(this.unit, data.trends, "visitors", this.startDate, this.endDate)
				    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, oldData.trends, "visitors", this.oldStartDate, this.oldEndDate)
			    }

			    // Optins
			    this.optins = data.optins;
			    this.optinsData = analytics.getDataFromTrends(this.unit, data.trends, "optins", this.startDate, this.endDate)
			    this.oldOptins = oldData.optins;
			    this.oldOptinsData = analytics.getDataFromTrends(this.unit, oldData.trends, "optins", this.oldStartDate, this.oldEndDate)

			    // Conversion rates
			    this.convRate = percentage(this.purchases, this.visitors);
			    this.convRates = analytics.generateRates(this.visitorsData, this.purchasesData);
			    this.oldConvRate = percentage(this.oldPurchases, this.oldVisitors);
			    this.oldConvRates = analytics.generateRates(this.oldVisitorsData, this.oldPurchasesData);

			    // Optin rates
			    this.optinRate = percentage(this.optins, this.visitors);
			    this.optinRates = analytics.generateRates(this.visitorsData, this.optinsData);
			    this.oldOptinRate = percentage(this.oldOptins, this.oldVisitors);
			    this.oldOptinRates = analytics.generateRates(this.oldVisitorsData, this.oldOptinsData);

			    this.steps = data.steps;

		    } catch (e) {
			    console.error("ERROR", e);
			    this.$notify({
				    group: 'main',
				    title: "Something went wrong! try again.",
				    type: 'error',
			    });
		    } finally {
			    this.loading = false;
		    }
	    },
    },

	mounted() {

	},
	created() {
		this.loadRange();

    this.loadAnalytics();

    // var {id} = this.$route.params
    // this.init(false, id);

  }
}
</script>
<style lang="scss" scoped>
.range-wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;

	.compare-to {
		margin: 0 10px;
	}
}
</style>

<style lang="scss" >
    .performance-breakdown {
      .analytics-table-container {
        overflow-x: scroll;
        overflow-x: overlay;

      }
        h2 {
            font-weight: 500;
            font-size: 18px;
            line-height: 150%;
            letter-spacing: 0.02em;
            color: #252A32;
            margin-bottom: 30px;
        }
        .step-name {
            a:hover {
                strong {
                    color: #4268e0;
                }
            }
        }

        .deleted {
            .step-name {
                .name {
                    color: #c6c6c6;
                }
            }
        }
    }

</style>
